import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useMixCategoryAutomationSettings() {
  const {
    tours: {
      ShippingAutomationSettings: { Mix },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Mix.Title,
      steps: [
        {
          content: Mix.Step1.Text,
          placement: 'auto',
          target: '#mixCategoryAutomation',
          title: Mix.Step1.Title,
          disableBeacon: true,
          link: Mix.Step1.DetailsLink,
        },
      ],
    }),
    [Mix],
  );

  return [pageTour];
}
